import React from 'react'
import Title from './title'
import MDText from './MDText'

const InfoBlock = ({
  title,
  extra,
  accentColor = 'white',
  text,
  style,
  children,
  bigTitle = false,
  childrenBetween = false,
}) => (
  <div style={style}>
    {title && (
      <Title title={title} style={{ fontSize: bigTitle ? 30 : 20 }}>
        {extra && (
          <Title
            title={` ${extra}`}
            style={{ fontSize: bigTitle ? 30 : 20, color: accentColor }}
          />
        )}
      </Title>
    )}
    {childrenBetween && children}
    {text && (
      <div style={textStyle}>
        <MDText source={text} />
      </div>
    )}
    {!childrenBetween && children}
  </div>
)

export default InfoBlock

const textStyle = {
  fontSize: '14px',
  margin: '1rem 0rem',
  lineHeight: 1.5,
  color: 'black',
}



// WEBPACK FOOTER //
// ./src/components/shared/infoBlock.js